var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 26,
  viewBox: "0 0 26 26",
  width: 26
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  fill: "#dd2525",
  r: 13
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: .5
}, /*#__PURE__*/React.createElement("path", {
  d: "m36.592.919a3.135 3.135 0 0 0 -4.435 0l-2.746 2.756a.48.48 0 1 0 .677.68l2.746-2.755a2.181 2.181 0 0 1 3.08 3.089l-3.627 3.638a.481.481 0 0 0 0 .68.478.478 0 0 0 .677 0l3.628-3.638a3.158 3.158 0 0 0 0-4.45z",
  transform: "translate(-17.143 5.342)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7.357 30.288-2.684 2.691a2.172 2.172 0 0 1 -3.079 0 2.192 2.192 0 0 1 0-3.089l3.626-3.638a.48.48 0 1 0 -.677-.68l-3.626 3.638a3.156 3.156 0 0 0 0 4.449 3.128 3.128 0 0 0 4.434 0l2.683-2.691a.48.48 0 0 0 -.677-.68z",
  transform: "translate(5.184 -14.057)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m54.594 36.929-1.749-.273a.481.481 0 0 0 -.148.95l1.749.273a.5.5 0 0 0 .075.005.481.481 0 0 0 .073-.955z",
  transform: "translate(-34.703 -22.614)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m48.074 45.7a.48.48 0 1 0 -.722.632l.8.92a.48.48 0 0 0 .722-.632z",
  transform: "translate(-30.846 -29.39)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m38.239 50.378a.479.479 0 1 0 -.932.224l.443 1.856a.48.48 0 0 0 .466.369.471.471 0 0 0 .112-.014.481.481 0 0 0 .354-.579z",
  transform: "translate(-23.263 -32.805)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m22.977 2.945a.482.482 0 0 0 .477-.538l-.211-1.763a.479.479 0 1 0 -.951.115l.208 1.762a.479.479 0 0 0 .474.424z",
  transform: "translate(-11.817 5.174)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.464 10.748a.48.48 0 1 0 .742-.608l-.715-.878a.48.48 0 1 0 -.742.608z",
  transform: "translate(-3.695 -1.588)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1.966 21.09 1.834.51a.474.474 0 0 0 .128.017.481.481 0 0 0 .128-.944l-1.834-.509a.481.481 0 0 0 -.255.927z",
  transform: "translate(3.952 -10.025)"
}))));
export default __webpack_public_path__ + "static/media/unlinkedorder.ce182fb3.svg";
export { SvgComponent as ReactComponent };